import { isValidNumber } from 'libphonenumber-js';
import * as Yup from 'yup';

import AssetsCountryInterface from '@api/requests/assets/interfaces/AssetsCountryInterface.interface';

import * as environment from '@utils/environment';

const isTermsRequired = environment.env.FIRM_ENVIRONMENT === '9cap';

const registrationFormValidationScheme = (assetsCountries: AssetsCountryInterface[]) =>
	Yup.object().shape({
		first_name: Yup.string().required('This field is required.'),
		last_name: Yup.string().required('This field is required.'),
		email: Yup.string()
			.matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Email address is invalid.')
			.required('This field is required.'),
		password: Yup.string()
			.required('This field is required.')
			.min(8, 'Password must be at least 8 characters long.')
			.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/, {
				message: 'Password must contain at least 1 lowercase character, 1 uppercase character and 1 number.',
			}),
		password_confirmation: Yup.string()
			.required('This field is required.')
			.min(8, 'Password must be at least 8 characters long.')
			.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/, {
				message: 'Password must contain at least 1 lowercase character, 1 uppercase character and 1 number.',
			})
			.oneOf([Yup.ref('password')], "Passwords don't match."),
		phone: Yup.object().shape({
			code: Yup.string()
				.required('Required.')
				.test('oneOfRequired', 'Invalid code.', value => {
					if (!value) return true;

					return assetsCountries.map(({ dial_code }) => dial_code).includes(value);
				})
				.test('startsWithPlus', 'Code must start with "+".', value => {
					return value?.startsWith('+');
				})
				.min(2, 'Code must be at least 2 characters (including "+").')
				.max(5, 'Code must be at most 5 characters (including "+").'),
			number: Yup.string()
				.required('This field is required.')
				.min(7, 'Phone number must be at least 7 digits long.')
				.max(15, 'Phone number must be at most 15 digits long.')
				.test('validPhoneNumber', 'Phone number is not valid.', function (value) {
					const code = this.parent.code;
					if (!code || !value) return true;

					return isValidNumber(`${code}${value}`);
				}),
		}),
		terms: Yup.boolean().test('isTrue', 'Terms must be accepted', function (value) {
			return !isTermsRequired || value === true;
		}),
	});

export default registrationFormValidationScheme;
